var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreValueIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.95 42.224h-.044a.71.71 0 01-.146-.022l-.007-.001C10.393 39.52 2.666 27.664 3.011 9.45a.728.728 0 01.802-.71c5.893.603 12.475-2.029 16.134-6.988a.728.728 0 01.586-.296h2.799c.231 0 .449.11.586.296 3.66 4.96 10.23 7.59 16.123 6.987a.73.73 0 01.802.71c.345 18.216-7.385 30.072-18.744 32.752l-.031.003.028-.003-.03.004a.688.688 0 01-.116.017zM20.895 2.913h2.075c3.831 4.958 10.38 7.681 16.427 7.339.104 16.82-6.907 27.906-17.47 30.493-10.563-2.587-17.574-13.673-17.47-30.493 6.047.342 12.606-2.38 16.438-7.339zm-7.383 24.676a10.144 10.144 0 01-1.777-5.749c0-5.625 4.567-10.191 10.192-10.191s10.191 4.566 10.191 10.191c0 5.363-4.15 9.763-9.41 10.162a.726.726 0 01-.777-.727c-.004 0-.004 0-.004-.002a.73.73 0 01.681-.727 8.735 8.735 0 008.054-8.706c0-4.821-3.914-8.735-8.735-8.735-4.822 0-8.736 3.914-8.736 8.735 0 1.824.56 3.517 1.517 4.918l.25-1.075a.728.728 0 111.419.33l-.66 2.836a.728.728 0 01-.875.544l-2.836-.66a.73.73 0 01.33-1.418l1.176.274zm4.26-4.506l2.912 2.912a.727.727 0 001.097-.078l4.368-5.824a.728.728 0 10-1.165-.873l-3.864 5.152-2.319-2.319a.728.728 0 00-1.029 1.03z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreValueIcon06);
export default __webpack_public_path__ + "static/media/core-value-icon06.1c23580ae978d68746df6bffe86339f6.svg";
export { ForwardRef as ReactComponent };